import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/customer/Landing";
import Booking from "@/pages/customer/Booking";
import BookingStatus from "@/pages/customer/BookingStatus";
import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import CalendarView from "@/pages/admin/CalendarView";
import Bookings from "@/pages/admin/Bookings";
import BookingDetail from "@/pages/admin/BookingDetail";
import NewBooking from "@/pages/admin/NewBooking";
import Customers from "@/pages/admin/Customers";
import Accounts from "@/pages/admin/Accounts";
import More from "@/pages/admin/More";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen gradient-navy flex items-center justify-center text-gold font-display text-2xl">قمرية...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" theme="dark" richColors closeButton dir="rtl" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/status/:id" element={<BookingStatus />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="calendar" element={<CalendarView />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="booking/:id" element={<BookingDetail />} />
            <Route path="new" element={<NewBooking />} />
            <Route path="customers" element={<Customers />} />
            <Route path="accounts" element={<Accounts />} />
            <Route path="more" element={<More />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
